export default {
  computed: {
    ocrControlQuickFilters() {
      return {
        title: this.$gettext('Shipment Files OCR'),
        filters: {
          columns: [
            {
              class: 'col-12 col-sm-4 col-lg-3',
              filters: [
                {
                  name: 'shipping-files-review-status',
                  label: this.$gettext('Review Status'),
                  type: 'radio-group',
                  value: 'manual',
                  stacked: true,
                  options: [
                    {
                      text: this.$gettext('Pending OCR'),
                      value: null
                    },
                    {
                      text: this.$gettext('Automatic'),
                      value: 'automatic'
                    },
                    {
                      text: this.$gettext('Need Review'),
                      value: 'manual'
                    },
                    {
                      text: this.$gettext('Reviewed'),
                      value: 'reviewed'
                    }
                  ],
                  callback: (val) => {
                    if (val === null || val === 'reviewed') {
                      return [
                        ['content_status', 'eq', val],
                        ['shipping_order.source', 'eq', 'manual']
                      ]
                    } else if (val) {
                      return [
                        ['meta->meta->processing', 'eq', val],
                        ['shipping_order.source', 'eq', 'manual']
                      ]
                    } else {
                      return []
                    }
                  }
                }
              ]
            },
            {
              class: 'col-12 col-md-6 col-lg-3',
              filters: [
                {
                  name: 'shipping-files-shipping-id',
                  label: this.$gettext('Shipment ID'),
                  type: 'text',
                  value: '',
                  callback: (val) => {
                    if (val.length > 0) {
                      return {
                        or: true,
                        filters: [
                          ['shipping_id', 'ct', val.trim()],
                          ['shipping.external_code', 'ct', val.trim()]
                        ]
                      }
                    } else {
                      return []
                    }
                  }
                },
                {
                  name: 'shipping-courier-company-id',
                  label: this.$gettext('Carrier'),
                  type: 'company-autocomplete',
                  restrictTo: [['relationship', 'eq', 'provider']],
                  value: [],
                  callback: (val) => {
                    if (val.length > 0) {
                      // Old courier_company_id
                      const carriers = val.map(function (item) {
                        return item.id
                      })
                      return [['shipping.courier_company_id', 'in', carriers]]
                    } else {
                      return []
                    }
                  }
                },
                {
                  name: 'shipping-files-created-at',
                  label: this.$gettext('Created At Date Range'),
                  type: 'daterange',
                  opens: 'center',
                  locale: {
                    format: this.$gettext('mm/dd/yyyy')
                  },
                  value: {
                    startDate: this.moment().subtract(2, 'day').toDate(),
                    endDate: this.moment().toDate(),
                    dateRangeActive: true
                  },
                  ranges: {
                    [this.$gettext('Today')]: [this.moment().toDate(), this.moment().toDate()],
                    [this.$gettext('Last 3 days')]: [this.moment().subtract(2, 'days').toDate(), this.moment().toDate()],
                    [this.$gettext('Last 7 days')]: [this.moment().subtract(6, 'day').toDate(), this.moment().toDate()],
                    [this.$gettext('Last 30 days')]: [this.moment().subtract(29, 'day').toDate(), this.moment().toDate()]
                  },
                  callback: (val, filtersState) => {
                    if (!(filtersState['shipping-files-shipping-id']) && val.dateRangeActive) {
                      const range = [
                        this.moment.tz(val.startDate, this.$tz).startOf('day').utc().format('YYYY-MM-DD HH:mm:ss'),
                        this.moment.tz(val.endDate, this.$tz).endOf('day').utc().format('YYYY-MM-DD HH:mm:ss')
                      ]
                      return [['created_at', 'bt', range]]
                    } else {
                      return []
                    }
                  }
                }
              ]
            },
            {
              class: 'col-12 col-md-6 col-lg-3',
              filters: [
                {
                  name: 'shipping-files-reference-location',
                  label: this.$gettext('Reference Location'),
                  type: 'text',
                  value: '',
                  callback: (val) => {
                    if (val.length > 0) {
                      return [['shipping_order.reference_location', 'sw', val.trim()]]
                    } else {
                      return []
                    }
                  }
                },
                {
                  name: 'commodity',
                  label: this.$gettext('Commodity'),
                  type: 'commodity-autocomplete',
                  minCharacter: 3,
                  value: '',
                  callback: (val) => {
                    if (val.id) {
                      return [['shipping_order.commodity_id', 'eq', val.id]]
                    } else {
                      return []
                    }
                  }
                },
                {
                  name: 'shipping-estimated-delivery-date',
                  label: this.$gettext('Est. Delivery Date Range'),
                  type: 'daterange',
                  opens: 'center',
                  locale: {
                    format: this.$gettext('mm/dd/yyyy')
                  },
                  value: {
                    startDate: null,
                    endDate: null,
                    dateRangeActive: false
                  },
                  ranges: {
                    [this.$gettext('Today')]: [this.moment().toDate(), this.moment().toDate()],
                    [this.$gettext('Last 3 days')]: [this.moment().subtract(2, 'days').toDate(), this.moment().toDate()],
                    [this.$gettext('Last 7 days')]: [this.moment().subtract(6, 'day').toDate(), this.moment().toDate()],
                    [this.$gettext('Last 30 days')]: [this.moment().subtract(29, 'day').toDate(), this.moment().toDate()]
                  },
                  callback: (val, filtersState) => {
                    console.log('FILTERS STATE*********', filtersState)
                    if (!(filtersState['shipping-files-shipping-id']) && val.dateRangeActive) {
                      const range = [
                        this.moment.tz(val.startDate, this.$tz).startOf('day').utc().format('YYYY-MM-DD HH:mm:ss'),
                        this.moment.tz(val.endDate, this.$tz).endOf('day').utc().format('YYYY-MM-DD HH:mm:ss')
                      ]
                      return [['shipping_order.delivery_date', 'bt', range]]
                    } else {
                      return []
                    }
                  }
                }
              ]
            },
            {
              class: 'col-12 col-md-6 col-lg-3',
              filters: [
                {
                  name: 'shipping-files-document-type',
                  label: this.$gettext('Document Type'),
                  type: 'document-type-autocomplete',
                  withUnknown: true,
                  value: null,
                  callback: (val) => {
                    if (val?.value) {
                      return [['meta->meta->document_type', 'eq', val.value]]
                    } else {
                      return []
                    }
                  }
                },
                {
                  name: 'shipping-files-type',
                  label: this.$gettext('Event'),
                  type: 'checkbox-group',
                  value: null,
                  stacked: true,
                  options: [
                    {
                      text: this.statusStrings.PICKEDUP,
                      value: 'PICKEDUP'
                    },
                    {
                      text: this.statusStrings.DELIVERED,
                      value: 'DELIVERED'
                    }
                  ],
                  callback: (val) => {
                    if (Array.isArray(val) && val.length > 0) {
                      return [['type', 'in', val]]
                    } else {
                      return []
                    }
                  }
                },
                {
                  name: 'shipping-files-source',
                  label: this.$gettext('Source'),
                  type: 'select',
                  value: null,
                  options: [
                    {
                      text: this.$gettext('All'),
                      value: null
                    },
                    {
                      text: this.$gettext('Not set'),
                      value: 'not-set'
                    },
                    {
                      text: this.$gettext('Web'),
                      value: 'web'
                    },
                    {
                      text: this.$gettext('Manual'),
                      value: 'manual'
                    }
                  ],
                  callback: (val) => {
                    if (val && val !== 'not-set') {
                      return [['source', 'eq', val]]
                    } else if (val === 'not-set') {
                      return [['source', 'eq', null]]
                    } else {
                      return []
                    }
                  }
                }
              ]
            }
          ]
        }
      }
    }
  }
}
